import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { paths } from '../../common/constants/pathVariables.js';
import { t } from '../../common/i18n/index.js';
import { getConfiguredCommercialProducts } from '../../common/utils/cartProductUtils.js';
import { getDeliveryCharges, isFinalPage } from '../../common/utils/checkoutUtils.js';
import { deepEqual } from '../../common/utils/objectUtils.js';
import { resetErrors } from '../../selfservice/actions/index.js';
import { DeviceCheckoutBillSummaryHeader } from '../DeviceCheckoutBillSummaryHeader/DeviceCheckoutBillSummaryHeader.js';
import { SmallHeader } from '../SmallHeader/SmallHeader.js';
import type { State } from '../../selfservice/common/store.js';

export interface EoeCheckoutHeaderProps {
  currentStep: number;
  redirectPath: string;
}

export const EoeCheckoutHeader = ({ currentStep, redirectPath }: EoeCheckoutHeaderProps) => {
  const { deliveryDetails, cartItems, listOfDeliveryMethods } = useSelector(
    (state: State) => ({
      deliveryDetails: state.deviceCheckout?.deliveryDetails,
      cartItems: state.deviceCheckout?.cartItems || [],
      listOfDeliveryMethods: state.deviceCheckout?.deliveryMethods?.lisOfDeliveryMethods,
    }),
    deepEqual
  );

  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const navigateToHome = () => {
    dispatch(resetErrors());
    navigate(paths.EMPLOYEE_HOME);
  };

  if (isFinalPage(pathname)) {
    return <SmallHeader buttonText={t.Z0U9(`Return to the Employee's OmaElisa`)} onClick={navigateToHome} />;
  } else if (currentStep >= 0 && currentStep < 1) {
    return (
      <SmallHeader
        buttonText={t.PLAW('Return to the shop')}
        onClick={() => {
          navigate(redirectPath, { state: { from: 'kassa' } });
        }}
      />
    );
  }

  return (
    <DeviceCheckoutBillSummaryHeader
      commercialProducts={getConfiguredCommercialProducts(cartItems)}
      deliveryCharges={getDeliveryCharges(deliveryDetails, listOfDeliveryMethods)}
      // Prices is always included with VAT for employee or consumer users.
      priceIncludesVAT={true}
    />
  );
};
